/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type IdentityGender = typeof IdentityGender[keyof typeof IdentityGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdentityGender = {
  M: 'M',
  F: 'F',
} as const;
